/**
 * Normalisation used to match brotherhood and place names across sources:
 * lowercase, no diacritics, no punctuation and without optional articles.
 */

const OPTIONAL_WORDS = new Set(['el', 'la', 'los', 'las', 'de', 'del']);

/** Lowercase, strip diacritics (ñ → n too) and punctuation, collapse whitespace. */
export function foldText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();
}

/**
 * Folded text without optional articles and prepositions
 * ("Esperanza de Triana" → "esperanza triana").
 * If dropping them would leave nothing meaningful ("La O"), they are kept.
 */
export function normalizeName(text: string): string {
  const folded = foldText(text);
  const kept = folded.split(' ').filter((w) => !OPTIONAL_WORDS.has(w));
  const result = kept.join(' ');
  return result.replace(/ /g, '').length < 2 ? folded : result;
}
